<template>
  <div class="cms-table">
    <table class="cms-table__el">
      <thead>
        <tr>
          <th v-for="(th, thIdx) in cmsTableHead.cmsTableHeads" :key="thIdx">
            {{ th.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tr, trIdx) in cmsTableBody" :key="trIdx">
          <td v-for="(td, tdIdx) in tr.cmsTableCols" :key="tdIdx" :data-title="titles[tdIdx]">
            <component :is="transformType(td.type)" v-bind="td" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import CmsRichText from '@/components/cms/cms-rich-text/cms-rich-text'
  import { transformType } from 'assets/js/util/misc/transform'

  export default {
    components: { CmsRichText },
    props: {
      cmsTableRows: {
        type: Array,
        required: true,
      },
    },
    computed: {
      cmsTableHead() {
        return this.cmsTableRows[0]
      },
      cmsTableBody() {
        const [, ...body] = this.cmsTableRows
        return body
      },
      titles() {
        return this.cmsTableHead.cmsTableHeads.map(({ title }) => title)
      },
    },
    methods: {
      transformType,
    },
  }
</script>

<style lang="scss" src="./_cms-table.scss" />
